/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCaseAttachmentDTO interface.
 */
export function instanceOfWarehouseCaseAttachmentDTO(value) {
    return true;
}
export function WarehouseCaseAttachmentDTOFromJSON(json) {
    return WarehouseCaseAttachmentDTOFromJSONTyped(json, false);
}
export function WarehouseCaseAttachmentDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'fileToken': json['fileToken'] == null ? undefined : json['fileToken'],
        'originalFilename': json['originalFilename'] == null ? undefined : json['originalFilename'],
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'fileSizeBytes': json['fileSizeBytes'] == null ? undefined : json['fileSizeBytes'],
        'publicUrl': json['publicUrl'] == null ? undefined : json['publicUrl'],
    };
}
export function WarehouseCaseAttachmentDTOToJSON(json) {
    return WarehouseCaseAttachmentDTOToJSONTyped(json, false);
}
export function WarehouseCaseAttachmentDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fileToken': value['fileToken'],
        'originalFilename': value['originalFilename'],
        'contentType': value['contentType'],
        'fileSizeBytes': value['fileSizeBytes'],
        'publicUrl': value['publicUrl'],
    };
}
